export default __webpack_public_path__ + "static/media/doc-contabili-dark.4b8338d2.svg";